import { RefObject, useEffect, useRef } from 'react';


export function useClickOutside<T extends HTMLElement> (
    callback: () => void,
    exceptions: RefObject<HTMLElement | null>[] = [],
) {
    const ref = useRef<T>(null);

    useEffect(() => {
        const handler = (event: MouseEvent | TouchEvent) => {
            const target = event.target as Node;

            const isException = exceptions.some(
                exception => exception.current?.contains(target),
            );

            if (ref.current && !ref.current.contains(target) && !isException) {
                callback();
            }
        };

        document.addEventListener('mousedown', handler);
        document.addEventListener('touchstart', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
            document.removeEventListener('touchstart', handler);
        };
    }, [ callback, exceptions ]);

    return ref;
}
